import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/shipping")({
  head: () => ({
    meta: [
      { title: "Shipping Policy · Buddha KA" },
      { name: "description", content: "Shipping timelines, rates, and delivery information for Buddha KA shop orders." },
      { property: "og:title", content: "Shipping Policy · Buddha KA" },
      { property: "og:description", content: "How and when Buddha KA ships physical orders." },
      { property: "og:url", content: "https://buddhaka.com/shipping" },
    ],
    links: [{ rel: "canonical", href: "https://buddhaka.com/shipping" }],
  }),
  component: ShippingPage,
});

function ShippingPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-24">
      <p className="text-xs uppercase tracking-[0.3em] text-gold">Legal</p>
      <h1 className="mt-4 font-serif text-5xl">Shipping Policy</h1>
      <p className="mt-3 text-xs text-muted-foreground">Last updated: July 15, 2026</p>

      <div className="mt-10 space-y-6 text-sm leading-relaxed text-muted-foreground">
        <h2 className="font-serif text-2xl text-foreground">Processing time</h2>
        <p>Orders are processed within 2-5 business days. Each order is packed by hand — we thank you for your patience.</p>

        <h2 className="font-serif text-2xl text-foreground">Domestic (United States)</h2>
        <ul className="list-disc space-y-1 pl-6">
          <li>Standard: 5-8 business days after processing.</li>
          <li>Expedited (where available): 2-3 business days.</li>
        </ul>

        <h2 className="font-serif text-2xl text-foreground">International</h2>
        <p>We ship worldwide. International delivery typically takes 10-21 business days after processing, depending on destination and customs. Import duties, taxes, and clearance fees are the responsibility of the recipient and are not included in shipping charges.</p>

        <h2 className="font-serif text-2xl text-foreground">Tracking</h2>
        <p>You will receive a tracking number by email once your order ships. Tracking is also visible in your account under Orders.</p>

        <h2 className="font-serif text-2xl text-foreground">Lost, delayed, or damaged</h2>
        <p>If a package is lost in transit or arrives damaged, email <a className="text-gold underline" href="mailto:support@buddhaka.com">support@buddhaka.com</a> within 14 days with your order number and photos (for damage). We will replace or refund at our discretion.</p>

        <h2 className="font-serif text-2xl text-foreground">Incorrect address</h2>
        <p>Please double-check your shipping address at checkout. If a package is returned undeliverable because of an incorrect address, you are responsible for reshipping costs.</p>

        <h2 className="font-serif text-2xl text-foreground">Digital orders</h2>
        <p>Music, books, and meditations do not ship — they unlock instantly in your account library after purchase.</p>
      </div>
    </div>
  );
}
